var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ErrorMsg = function (_a) {
    var id = _a.id, error = _a.error;
    var htmlId = "ImBoxNKIError-".concat(id);
    return (_jsxs("div", __assign({ id: htmlId, dir: "auto", className: "input-error" }, { children: [_jsx("i", __assign({ className: 'material-icons input-error-icon' }, { children: "error" }), void 0), _jsx("span", { children: error }, void 0)] }), void 0));
};
